import * as React from "react"
import { useExportTransactionsLazyQuery } from "@digits-graphql/frontend/graphql-bearer"
import { SvgAlertTriangleSolid } from "@digits-shared/components/SVGIcons/solid/AlertTriangleSolid.svg"
import { SvgCheckCircleSolid } from "@digits-shared/components/SVGIcons/solid/CheckCircleSolid.svg"
import {
  type ExportPropsWithoutToVault,
  useExportVariables,
} from "src/frontend/components/OS/Applications/Shared/Accounting/Exports/hooks/useExportVariables"
import { useChromeAlertContext } from "src/frontend/components/Shared/Alerts/ChromeAlertsContext"
import { useDownloadUrls } from "src/frontend/hooks/useDownloadUrls"

export function useExportToCsv(props: ExportPropsWithoutToVault) {
  const variables = useExportVariables({ ...props, toVault: false })
  const { addAlert } = useChromeAlertContext()
  const download = useDownloadUrls()
  const [exportToVault] = useExportTransactionsLazyQuery()

  return React.useCallback(() => {
    addAlert({
      id: "downloading-transactions",
      message: "Downloading…",
      SVGComponent: SvgCheckCircleSolid,
      autoDismiss: true,
    })

    exportToVault({
      variables,
      fetchPolicy: "no-cache",
    })
      .then((res) => {
        const downloadUrl = res.data?.exportTransactions.downloadUrl
        if (downloadUrl) {
          download([{ url: downloadUrl }])
        }
      })
      .catch(() => {
        addAlert({
          id: "csv-export-error",
          message: "Unable to download csv",
          SVGComponent: SvgAlertTriangleSolid,
          autoDismiss: true,
        })
      })
  }, [addAlert, download, exportToVault, variables])
}
